<template>
  <div v-if="tips">
    <div class="tip" v-for="tip in tips">
      <div
        v-if="tip.type == '0'"
        class="flex items-center p-2"
      >
        <div class="w-1/6 xl:pl-3">
          <i :class="iconHelp"></i>
        </div>
        <div class="w-5/6 text-grey-dark text-sm italic"><span v-html="tip.content"></span></div>
      </div>

      <div
        v-else-if="tip.type == '1'"
        class="flex items-center p-2"
      >
        <div class="w-1/6 xl:pl-3">
          <i :class="iconWarning"></i>
        </div>
        <div class="w-5/6 text-grey-dark text-sm italic"><span v-html="tip.content"></span></div>
      </div>

      <div
        v-else-if="tip.type == '2'"
        class="flex items-center p-2"
      >
        <div class="w-1/6 xl:pl-3">
          <i :class="iconInfo"></i>
        </div>
        <div class="w-5/6 text-grey-dark text-sm italic"><span v-html="tip.content"></span></div>
      </div>
    </div>
  </div>
</template>

<script>
// <img :src="iconHelp"  width="50px" />
// <img :src="iconWarning"  width="50px" />
// <img :src="iconInfo"  width="50px" />

export default {
  name: "sp-tips",
  data() {
    return {
      iconWarning:
        "fa fa-exclamation fa-2x inline-block w-8 h-8 text-center text-white text-base font-300 leading-loose rounded-full bg-red-dark",
      iconInfo:
        "fa fa-info fa-2x inline-block w-8 h-8 text-center text-white text-base font-300 leading-loose rounded-full bg-blue-light",
      iconHelp:
        "fa fa-check fa-2x inline-block w-8 h-8 text-center text-white text-base font-300 leading-loose rounded-full bg-green"
    };
  },
  props: {
    tips: {
      required: false,
      type: Array,
      default: null
    }
  }
};
</script>

<style></style>
